import gsap from 'gsap'
import store from '../util/store'

export default class Menu {
  constructor() {
    this.entryOpened = null
    this.subLinksOpened = null
    this.lenis = store.smoothScroll

    this.bindMethods()
    this.getElems()
    this.gsapInit()
    this.addEvents()
    // this.footerScroll()
    this.scroll()
    this.mobileFunctionality();

    this.onPageChange(window.location.href)
  }

  bindMethods() {
    this.toggle = this.toggle.bind(this)
    this._toggleSearch = this._toggleSearch.bind(this)
  }

  getElems() {
    this.header = document.querySelector('header')
    this.entries = Array.from(this.header.querySelectorAll('.entry.--has-sub')).map((entry) => {
      const entryEls = {}

      entryEls.el = entry

      entryEls.header = {
        el: entry.querySelector('.submenu-header'),
        chevron: entry.querySelector('.submenu-header svg')
      }

      entryEls.menu = {
        el: entry.querySelector('.submenu'),
        type: entry.querySelector('.submenu').classList.contains('--links') ? 'links' : 'columns'
      }

      if (entryEls.menu.type === 'columns') {
        const columns = []

        Array.from(entryEls.menu.el.querySelectorAll('.column')).forEach((column) => {
          const subLinks = []

          if (column.offsetHeight > window.innerHeight * 0.6) {
            column.classList.add('--column-scroll')
          } else {
            column.classList.add('--no-scroll');
          }

          Array.from(column.querySelectorAll('.sublinks')).forEach((subLink) => {
            subLinks.push({
              el: subLink,
              header: subLink.querySelector('.sublinks-header'),
              links: subLink.querySelector('.sublinks-links')
            })
          })

          columns.push({
            el: column,
            return: column.querySelector('.return'),
            titleHeight: column.querySelector('.title').offsetHeight,
            subLinks
          })
        })

        entryEls.menu.columns = columns
      }

      return entryEls
    })
    this.search = {
      isOpened: false,
      toggle: document.querySelector('header .buttons .search__toggle'),
      form: document.getElementById('ajax-search-form'),
      searchInput: document.getElementById('ajax-search-input'),
      resultsContainer: document.getElementById('ajax-search-results')
    }
    this.footer = document.querySelector('footer')
    this.footerInner = this.footer.querySelector('.footer__inner')
    this.hasHeroBanner = document.querySelector('.b-hero-banner') !== null
  }

  gsapInit() {
    if (this.hasHeroBanner) {
      this.header.classList.add('--glass')
    }

    this.entries.forEach((entry) => {
      const bottom = -7200 / 1512 + 'vw'

      gsap.set(entry.menu.el, {
        bottom,
        opacity: 0,
        visibility: 'hidden'
      })
    })
  }

  _toggleMenu(entry, open) {
    const bottomOpened = -2400 / 1512 + 'vw'
    const bottomClosed = -7200 / 1512 + 'vw'

    const tl = gsap.timeline({
      defaults: {
        duration: 0.3,
        ease: 'power.inOut'
      },
      onComplete: () => {
        if (this.subLinksOpened) {
          this.subLinksOpened.links.classList.remove('--open')
          this.subLinksOpened = null
        }
      }
    })

    if (open) {
      entry.header.el.classList.add('--sub-open')
      entry.menu.el.addEventListener('wheel', (e) => e.stopPropagation())
      this.header.classList.add('--active')

      tl
      .to(entry.menu.el, {
        visibility: 'visible',
        duration: 0
      })
      .to(entry.menu.el, {
        bottom: bottomOpened,
        opacity: 1
      })
      .to(entry.header.chevron, {
        scaleY: -1
      }, '<')
    } else {
      entry.header.el.classList.remove('--sub-open')
      entry.menu.el.removeEventListener('wheel', (e) => e.stopPropagation())
      this.header.classList.remove('--active')

      tl
      .to(entry.menu.el, {
        bottom: bottomClosed,
        opacity: 0
      })
      .to(entry.menu.el, {
        visibility: 'hidden',
        duration: 0
      })
      .to(entry.header.chevron, {
        scaleY: 1
      }, '<')

      if (entry.menu.type === 'columns') {
        entry.menu.columns.forEach((column) => {
          column.el.classList.remove('--sub-open')
          column.el.classList.remove('--scroll')
        })
      }
    }
  }

  _toggleSearch() {
    const tl = gsap.timeline({
      onComplete: () => {
        this.search.isOpened = !this.search.isOpened
      }
    })

    if (this.search.isOpened) {
      tl.to(this.search.form, {
        top: 12000 / 1512 + 'vw',
        opacity: 0,
        ease: 'power3.out',
        duration: 0.4
      }).to(this.search.form, {
        visibility: 'hidden'
      })
    } else {
      tl.to(this.search.form, {
        visibility: 'visible'
      }).to(this.search.form, {
        top: 7200 / 1512 + 'vw',
        opacity: 1,
        ease: 'power3.out',
        duration: 0.4
      })
    }
  }

  isMobile() {
    return window.innerWidth <= 1024;
  }

  mobileFunctionality() {
    if (this.isMobile()) {
      this.entries.forEach((entry) => {
        entry.header.el.addEventListener('click', () => {
          this._toggleMenu(entry, true);
        });

        if (entry.menu.type === 'columns') {
          entry.menu.columns.forEach((column) => {
            column.el.addEventListener('click', () => {
              entry.menu.columns.forEach((col) => {
                col.el.classList.remove('open--col');
              });

              column.el.classList.add('open--col');

              const columnLinks = column.el.querySelector('.column-links');

              if (columnLinks) {
                const contentHeight = columnLinks.scrollHeight;

                columnLinks.style.height = `${contentHeight}px`;
              }

              const sublinksLinks = column.el.querySelectorAll('.sublinks-links');

              sublinksLinks.forEach((sublink) => {
                sublink.style.visibility = 'hidden';
                setTimeout(() => {
                  const links = sublink.querySelectorAll('a');
                  const linksHeight = links.length * 56 + 90;

                  sublink.style.height = `${linksHeight}px`;
                  sublink.style.visibility = 'visible';
                }, 300);
              });
            });
          });
        }
      });

      const backButton = document.querySelector('.backbutton');

      if (backButton) {
        backButton.addEventListener('click', () => {
          if (this.openedEntry) {
            this._toggleMenu(this.openedEntry, false);
            this.openedEntry = null;
          }
        });
      }

      const backButtonLevel1 = document.querySelector('.backbutton-level1');

      if (backButtonLevel1) {
        backButtonLevel1.addEventListener('click', () => {
          this.entries.forEach((entry) => {
            if (entry.menu.type === 'columns') {
              entry.menu.columns.forEach((column) => {
                column.el.classList.remove('open--col');
              });
            }
          });
        });
      }

      const backButtonLevel2 = document.querySelector('.backbutton-level2');

      if (backButtonLevel2) {
        backButtonLevel2.addEventListener('click', () => {
          const openSublinks = document.querySelectorAll('.sublinks-links.--open');

          openSublinks.forEach((sublink) => {
            sublink.classList.remove('--open');
          });
        });
      }

      const checkSublinksOpen = () => {
        const openSublinks = document.querySelector('.sublinks-links.--open');
        const columnLinks = document.querySelector('.column-links');

        if (openSublinks && columnLinks) {
          columnLinks.scrollTop = 0;
        }
      };

      const sublinksHeaders = document.querySelectorAll('.sublinks-header');

      sublinksHeaders.forEach((header) => {
        header.addEventListener('click', () => {
          checkSublinksOpen();
        });
      });

      const burgerMenu = document.querySelector('.burger-menu');
      const entriesElement = document.querySelector('.entries');
      const contentElement = document.querySelector('.content');

      if (burgerMenu && entriesElement) {
        burgerMenu.addEventListener('click', () => {
          burgerMenu.classList.toggle('change');
          entriesElement.classList.toggle('in-view');

          if (entriesElement.classList.contains('in-view')) {
            contentElement.classList.add('blur-background');
            document.body.style.position = 'fixed';
          } else {
            contentElement.classList.remove('blur-background');
            document.body.style.position = 'inherit';
          }
        });
      }
    }
  }

  addEvents() {
    this.entries.forEach((entry) => {
      entry.header.el.addEventListener('click', () => {
        if (this.openedEntry) {
          if (this.openedEntry === entry) {
            this._toggleMenu(entry, false)
            this.openedEntry = null
          } else {
            this._toggleMenu(this.openedEntry, false)
            this._toggleMenu(entry, true)
            this.openedEntry = entry
          }
        } else {
          this._toggleMenu(entry, true)
          this.openedEntry = entry
        }
      })

      if (entry.menu.type === 'columns') {
        entry.menu.columns.forEach((column) => {
          column.subLinks.forEach((subLink) => {
            subLink.header.addEventListener('click', () => {
              const scrollTop = column.el.querySelector('.column-links').scrollTop

              subLink.links.style.top = scrollTop + 'px'
              if (window.matchMedia('(min-width: 1024px)').matches) {
                column.el.querySelector('.column-links').style.overflow = 'hidden';
              } else {
                column.el.querySelector('.column-links').style.overflow = 'auto';
              }
              subLink.links.classList.add('--open')
              column.el.classList.add('--sub-open')
              this.subLinksOpened = subLink

              if (subLink.links.scrollHeight > subLink.links.offsetHeight) {
                column.el.classList.add('--scroll')
              }
            })
          })

          column.return.addEventListener('click', () => {
            column.el.querySelector('.column-links').style.overflowY = 'scroll'

            column.subLinks.forEach((subLink) => {
              subLink.links.classList.remove('--open')
            })

            column.el.classList.remove('--scroll')
            column.el.classList.remove('--sub-open')
            this.subLinksOpened = null
          })
        })
      }
    })

    this.search.toggle.addEventListener('click', () => {
      this._toggleSearch()
    })

    this.search.searchInput.addEventListener('input', () => {
      const query = this.search.searchInput.value

      if (query.length < 3) {
        this.search.resultsContainer.innerHTML = ''
        this.search.resultsContainer.style.background = '#fff';

        return
      }

      fetch(`/wp-admin/admin-ajax.php?action=custom_search&s=${encodeURIComponent(query)}`)
        .then((response) => response.json())
        .then((data) => {
            this.search.resultsContainer.innerHTML = ''

            if (data.success) {
                const results = data.data

                results.forEach((item) => {
                    const resultItem = document.createElement('div')

                    resultItem.innerHTML = `<a href="${item.link}">${item.title}</a>`
                    this.search.resultsContainer.appendChild(resultItem)
                })
            } else {
                this.search.resultsContainer.innerHTML = '<div>No results found.</div>'
            }
        })
        .catch((error) => {
            console.error('Search error:', error);
            this.search.resultsContainer.innerHTML = '<div>Error fetching results.</div>'
        })

    })


    document.addEventListener('click', (event) => {
      if (this.openedEntry && !this.header.contains(event.target) && !this.openedEntry.header.el.contains(event.target)) {
        this._toggleMenu(this.openedEntry, false)
        this.openedEntry = null
      }
    })
  }

  toggle() {
    if (this.isAnimating) return

    if (this.menuOpen) this.close()
    else this.open()
  }

  open() {
    return new Promise((resolve) => {
      this.menuOpen = true
      resolve()
    })
  }

  close() {
    return new Promise((resolve) => {
      this.menuOpen = false
      resolve()
    })
  }

  footerScroll() {
    if (!this.footer) return

    if (window.innerWidth < 1024) return

    gsap.fromTo(this.footerInner, {
      yPercent: -40
    }, {
      yPercent: 0,
      scrollTrigger: {
        trigger: this.footer,
        start: 'top bottom',
        end: 'bottom bottom',
        scrub: 1
      }
    })
  }

  resize() {}

  scroll() {
    this.lenis.on('scroll', (e) => {
      if (e.direction === 1) {
        if (!this.header.classList.contains('--active')) {
          this.header.classList.add('--scroll')
        }
      } else {
        this.header.classList.remove('--scroll')
      }

      if (this.hasHeroBanner) {
        if (e.scroll > window.innerHeight - 120) {
          this.header.classList.remove('--glass')
        } else {
          this.header.classList.add('--glass')
        }
      }
    })
  }

  // eslint-disable-next-line no-unused-vars
  onPageChange(loc) {}
}
